import { initNavMenus } from "./common/navMenu.js";
import renderContactForm from "./components/ContactForm/renderContactForm.jsx";
import handleSubnav from "./components/IntroSubnav/handleSubnav.js";
document.addEventListener("DOMContentLoaded", () => {
    // other render functions here
    initNavMenus();
    renderContactForm();
    handleSubnav();
});